import React from 'react'
import PropTypes from 'prop-types'
import { Main } from '@/components/Layout/index'
import { localized } from '@/decorators/localized'
import { Dashboard } from '@/components/dashboard'

@localized()
class Home extends React.Component {
  static propTypes = {
    localize: PropTypes.func
  }

  render () {
    const { localize } = this.props
    return (
      <Main className='dashboard'>
        <div className='dashboard__inner'>
          <Dashboard localize={localize} />
        </div>
      </Main>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/report-app/pages/Home.js